
export const MIN_ZOOM = 0.2
export const MAX_ZOOM = 10

export const drawerWidth = 240

export const emptyObject = {}
